import { Input } from 'antd';

const AntInput = ({ inputType, placeholder, textAreaRows, label, onChange, value,size,status}) => {

    return (
        inputType !== "textarea" ?
            <Input status={status} placeholder={placeholder} value={value} addonBefore={label} onChange={onChange} size={size}/>

            : <Input.TextArea status={status} rows={textAreaRows} value={value} placeholder={placeholder} addonBefore={label} onChange={onChange} size={size}/>
    );
};
export default AntInput;
